export const mentionTextArea = (valueKey, titleKey, endpoint) => {
	return {
		data: [],
		active: [],
		content: '',
		htmlContent: '',
		open: false,
		pending: false,
		valueKey,
		titleKey,
		endpoint,
		handleInput() {
			this.createMentions();
		},

		handleChooseMention(item) {
			if (!item) {
				return;
			}
			const parts = this.content.split(" ")
			const lastPart = parts[parts.length - 1]
			const title = String(item[titleKey] ?? '').replaceAll(' ', '_')
			const value = item[valueKey]
			if (title.length === 0 || value === undefined || value === null) {
				return
			}
			this.content = this.content.slice(0, this.content.length - lastPart.length) + `@${title}`
			this.createMentions()
			this.open = false
			this.$refs.textarea.focus()
			this.active = this.getActive()
			this.addMention(value, title);
			this.createMentions();
		},

		addMention(userId, userName) {
			let mentionsJson = this.$refs.mentionsData.value;
			let mentionsArray = mentionsJson ? JSON.parse(mentionsJson) : [];

			let newMention = { name: userName, id: userId };
			mentionsArray.push(newMention);

			this.$refs.mentionsData.value = JSON.stringify(mentionsArray);
		},

		async validateMention() {
			this.active = this.getActive()
			const parts = this.content.split(" ")
			const lastPart = parts[parts.length - 1]
			const mentionSymbolExists = lastPart.includes('@')
			if (!mentionSymbolExists) {
				this.data = []
				this.open = false
			}
			if (mentionSymbolExists) {
				const search = lastPart.replace('@', '')
				if (search.length === 0) {
					return
				}
				this.open = true
				this.pending = true
				this.data = await this.$get(endpoint + (search.length > 0 ? '&search=' + search : ''))
				this.pending = false
			}
		},

		createMentions() {
			let mentionsJson = this.$refs.mentionsData.value;

			if (mentionsJson.length === 0) {
				return;
			}
			let mentionCount = 0;
			let mentions = JSON.parse(mentionsJson);
			this.htmlContent = this.content.replace(/(@\w+)/g, (match) => {
				let name = match.substring(1);

				if (typeof mentions[mentionCount] == 'undefined') {
					return match;
				} else if (mentions[mentionCount].name !== name) {
					if (this.isNameDeleted(mentions[mentionCount].name, name)) {
						this.deleteMention(mentionCount, name);
						mentionCount++
					}
					return match;
				} else {
					let formatedName = '<span class="border-b border-primary cursor-pointer" data-id="' + mentions[mentionCount].id + '">' + match + '</span>';
					mentionCount++;
					return formatedName;
				}
			})


		},
		deleteMention(mentionPosition, nameToDelete) {
			let mentionsJson = this.$refs.mentionsData.value;
			let mentions = JSON.parse(mentionsJson);

			mentions.splice(mentionPosition, 1);
			this.content = this.content.replace('@' + nameToDelete, '');
			this.$refs.mentionsData.value = JSON.stringify(mentions);
		},
		revalidateJson() {
			this.content.replace(/(@\w+)/g, (match) => {
				let mentionsJson = this.$refs.mentionsData.value;
				if (mentionsJson.length === 0) {
					return match;
				}

				let mentions = JSON.parse(mentionsJson);
				let nameInText = match.substring(1);
				for (let i = 0; i < mentions.length; i++) {
					if (this.isNameDeleted(mentions[i].name, nameInText)) {

						mentions.splice(i, 1);
						this.$refs.mentionsData.value = JSON.stringify(mentions);
						return '';
					}
				}
			})
		},

		isNameDeleted(savedName, nameInText) {
			if (savedName === nameInText) {
				return false;
			}

			for (let i = 0; i < savedName.length; i++) {
				let checkName = savedName.slice(0, i) + savedName.slice(i + 1);

				if (checkName === nameInText) {
					return true;
				}
			}
			return false;
		},
		getActive() {
			return (this.content.match(/@\w+/g) || []).map(item => item.replace('@', '').replaceAll('_', ' '))
		}
	}
}

export const mentionHighlight = (mentionsJson, note) => {
	return {
		htmlContent: note,
		mentionsJson,
		handleHighlightMentions() {
			if (mentionsJson.length === 0) {
				return;
			}

			let mentions = JSON.parse(mentionsJson);
			let mentionCount = 0;
			let regex = /@[\w]+/g;

			this.htmlContent = this.htmlContent.replace(regex, (match) => {
				let name = match.substring(1);
				if (typeof mentions[mentionCount] == 'undefined' || mentions[mentionCount].name !== name) {
					return match;
				} else {
					let formatedName =  '<span class="border-b border-primary" data-id="' + mentions[mentionCount].id + '">' + match + '</span>';
					mentionCount++;
					return formatedName;
				}
			});

		}

	}
}
